module.exports = __webpack_public_path__ + "static/img/30013 (1).56eb3ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30013 (1).jpg
// module id = Znns
// module chunks = 14